// utils
import { _val } from 'app/utils';

export const prescriptionTypeInitFormFn = (values = {}) => {
  return {
    prescriptionType: _val(values.prescriptionType, null),
    medicamentId: _val(values.medicamentId, null),
    evaluationTypeId: _val(values.evaluationTypeId, null),
    procedureId: _val(values.procedureId, null),
    NANDAProcedureId: _val(values.NANDAProcedureId, null),
    dietId: _val(values.dietId, null),
    supplied: _val(values.supplied, null),

    formAddOn: {
      medicament: _val(values.medicament, {}),
      evaluationType: _val(values.evaluationType, {}),
      procedure: _val(values.procedure, {}),
      NANDAProcedure: _val(values.NANDAProcedure, {}),
      diet: _val(values.diet, {}),
      unity: _val(values.unity, {})
    }
  };
};
